import { render, staticRenderFns } from "./regionTargetBtn.vue?vue&type=template&id=17a8cabc&"
import script from "./regionTargetBtn.vue?vue&type=script&lang=js&"
export * from "./regionTargetBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports